import { render, staticRenderFns } from "./IslemDetay.vue?vue&type=template&id=048960ec&scoped=true&"
import script from "./IslemDetay.vue?vue&type=script&lang=js&"
export * from "./IslemDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048960ec",
  null
  
)

export default component.exports